//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'EcoPartModal',
  components: {
    MdmModal
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  }
};